import { render } from "./EditProfesseur.vue?vue&type=template&id=62535faa&ts=true"
import script from "./EditProfesseur.vue?vue&type=script&lang=ts"
export * from "./EditProfesseur.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__